// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"4b6d0b2d","462":"6a9f4b84","472":"0342c131","583":"b5281b01","689":"11beb8a0"}[chunkId] + ".chunk.js";
};